import RteBlock from './RteBlock';

export default RteBlock;
